module.exports = __webpack_public_path__ + "img/Valenciano.c8ba485b.png";